export enum EntityType {
  Agents = 'AGENTS',
  Evaluators = 'EVALUATORS',
  Personas = 'PERSONAS',
}

export enum EntitySortOrder {
  Alphabetical = 'ALPHABETICAL',
  MostRecent = 'MOST_RECENT',
}

export enum PersonaGender {
  Male = 'MALE',
  Female = 'FEMALE',
  NonBinary = 'NON_BINARY',
  NoneDisclosed = 'NONE_DISCLOSED',
}
